import { SignIn, SignUp } from "@clerk/clerk-react";
import React from "react";
import RememberMeCheckbox from "../molecules/RememberMeCheckbox";
import WelcomePanel from "../organisms/WelcomePanel";

/**
 * AuthLayout - Layout template for authentication pages
 *
 * @param {Object} props
 * @param {string} props.type - Layout type: "signin", "signup", or "welcome"
 */
const AuthLayout = ({ type = "signin" }) => {
  if (type === "welcome") {
    return <WelcomePanel />;
  }

  return (
    <div className="min-h-screen bg-[#0f1418] flex flex-col items-center justify-center p-4">
      {type === "signin" ? (
        <div className="animate-in fade-in duration-500 slide-in-from-bottom-4">
          <SignIn
            routing="path"
            path="/sign-in"
            appearance={{
              elements: {
                formButtonPrimary:
                  "bg-[#4db1e0] hover:bg-[#3da0cf] transition-colors duration-200",
                card: "bg-[#1a1e21] text-white max-w-md w-full shadow-md hover:shadow-lg transition-shadow duration-300",
                headerTitle: "text-[#4db1e0]",
                headerSubtitle: "text-gray-300",
                socialButtonsIconButton:
                  "border-gray-600 text-white hover:bg-[#262b30] transition-colors duration-200",
                formFieldLabel: "text-gray-300",
                formFieldInput:
                  "bg-[#262b30] border-gray-600 text-white focus:border-[#4db1e0] transition-colors duration-200",
                footerActionLink:
                  "text-[#4db1e0] hover:text-[#5dc9fc] transition-colors duration-200",
              },
            }}
            signUpUrl="/sign-up"
          >
            <RememberMeCheckbox />
          </SignIn>
        </div>
      ) : (
        <div className="animate-in fade-in duration-500 slide-in-from-bottom-4">
          <SignUp routing="path" path="/sign-up" />
        </div>
      )}
    </div>
  );
};

export default AuthLayout;
